import { Component, inject, OnInit } from '@angular/core';
import { AuthService, ToastService } from 'libs/core/src/public-api';
import { FormGroup } from '@angular/forms';
import {
  FormFactoryComponent,
  FormFactoryService,
} from 'ngx-dynamic-forms-factory';
import { LoginFieldsService } from '../../services/login-fields.service';
import { TranslateModule } from '@ngx-translate/core';
import { RouterLink } from '@angular/router';
import { ButtonComponent } from 'libs/ui/src/public-api';

@Component({
  selector: 'lib-forgot-password',
  imports: [ButtonComponent, FormFactoryComponent, TranslateModule, RouterLink],
  templateUrl: './forgot-password.component.html',
})
export class ForgotPasswordComponent implements OnInit {
  authService = inject(AuthService);

  form!: FormGroup;
  formFactory = inject(FormFactoryService);
  fieldsService = inject(LoginFieldsService);
  toastService = inject(ToastService);

  ngOnInit(): void {
    this.form = this.formFactory.createForm(
      this.fieldsService.forgotPasswordFields,
    );
  }

  onSendEmail() {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    this.authService.forgotPassword(this.form.getRawValue());
  }
}
